import { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { RecordSection } from '../../components/record/RecordPage.tsx';
import { NoRelationshipHistory } from '../../relationships/NoRelationshipHistory.tsx';
import { WhoKnowsThemList } from '../../relationships/WhoKnowsThemList.tsx';
import {
  fetchCompanyPaths,
  type CompanyRelationshipPath
} from '../../relationships/relationshipApi.ts';
import { getErrorMessage } from '../../utils/helperUtils.ts';

export const CompanyRelationshipSection = ({ companyId }: { companyId: number }) => {
  const [paths, setPaths] = useState<CompanyRelationshipPath[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let current = true;
    setPaths(null);
    setError(null);
    fetchCompanyPaths(companyId)
      .then((rows) => {
        if (current) setPaths(rows);
      })
      .catch((err) => {
        if (current) setError(getErrorMessage(err));
      });
    return () => {
      current = false;
    };
  }, [companyId]);

  return (
    <RecordSection
      title="Who here knows them"
      description="Colleagues ranked by their warmest contact at this company."
    >
      {error ? (
        <Alert severity="error">Could not load relationships: {error}</Alert>
      ) : !paths ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1 }}>
          <CircularProgress size={18} />
          <Typography variant="body2" color="text.secondary">
            Loading relationships
          </Typography>
        </Box>
      ) : !paths.length ? (
        <NoRelationshipHistory who="anyone here" />
      ) : (
        <WhoKnowsThemList paths={paths} />
      )}
    </RecordSection>
  );
};
